import { useEffect, useState } from "react";

const ConfirmationModal=({modalMessage,confirmFunc,cancelFunc})=>{
    const[isVisible,setIsVisible]=useState(false);

    const handleConfirm=()=>{
        setIsVisible(false);
        setTimeout(() => {confirmFunc()}, 300);
    }

    const handleClose=()=>{
        setIsVisible(false);
        setTimeout(() => {cancelFunc(false)}, 300);
    }

    const handleModalClick = (e) => {
        // Execute modalFunc when clicking the modal background
        handleClose();
    };
    
    const handleChildClick = (e) => {
        // Stop event propagation when clicking on child nodes
        e.stopPropagation();
    };

    useEffect(()=>{
        setIsVisible(true);
    },[]);

    return(
        <div tabIndex="-1" className={`fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-full max-h-full alim-modal flex justify-center items-center bg-gray-900/50 dark:bg-gray-900/80 transition-opacity duration-300 ${isVisible?`opacity-100`:`opacity-0`}`} onClick={handleModalClick}>
            <div className="relative p-4 w-full max-w-md max-h-full" onClick={handleChildClick}>
                <div className="relative alim-modal-bg-color-style rounded-lg shadow">
                    <button type="button" className="absolute top-3 end-2.5 modal-close-btn rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center" onClick={handleClose}>
                        <span className="modal-close-img-elem w-[12px] h-[12px]"></span>
                        <span className="sr-only">Close modal</span>
                    </button>
                    <div className="p-4 md:p-5 text-center">
                        <div className="info-img-elem w-[48px] h-[48px] mx-auto my-3"></div>
                        <h3 className="mb-5 text-lg font-normal alim-text-color-style">{modalMessage}</h3>
                        <button type="button" className="text-white bg-deep-red font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center me-2" onClick={handleConfirm}>
                            Yes, I'm sure
                        </button>
                        <button type="button" className="text-white bg-dark_blue rounded-lg text-sm font-medium px-5 py-2.5" onClick={handleClose}>
                            No, Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationModal;